module.exports = __webpack_public_path__ + "img/CommunityLook.ebfce173.png";